import React, { useContext } from 'react'
import { FormContext } from '../../views/Connectors/FormContext';
import {
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Row,
    Col,
    FormGroup,
    Input,
    Label,
    Button
  } from "reactstrap";
  import Switch from "react-bootstrap-switch";

const SwitchBox = ({key, id,label, placeholder, fieldValue, required }) => {
    const { handleChange } = useContext(FormContext)
    return(
        <div className="mb-3 form-group" >
            <Label>{placeholder}</Label>&nbsp; &nbsp;&nbsp; &nbsp;
            <Switch onChange={(event, state) => handleChange(id, state)}
            value={fieldValue} 
            name='enbale connector' 
            data-on-color="secondary" 
            data-off-color="default" />
        </div>    
    )

}
export default SwitchBox